<script lang="ts">
  import Icon from '../icons/Icon.svelte';
  const apps = ['VuChat', 'VuMail', 'VuPhoto', 'VuNotes', 'VuVault'];
</script>

<div class="ribbon">
  <div class="wrap ribbon-inner">
    <div class="ribbon-l">
      <Icon name="globe" size={22} />
      <span class="ribbon-l-text">
        <strong>Part of the VU ecosystem.</strong>
        30+ apps, one philosophy: YOUR data. YOUR device. YOUR control.
      </span>
    </div>
    <div class="ribbon-r">
      {#each apps as app (app)}
        <span class="ribbon-chip">{app}</span>
      {/each}
    </div>
  </div>
</div>

<style>
  .ribbon {
    border-top: 1px solid var(--border);
    border-bottom: 1px solid var(--border);
    padding: 32px 0;
    background: var(--bg-card);
  }
  :global([data-theme='brutalist']) .ribbon {
    border-top: 2px solid var(--text);
    border-bottom: 2px solid var(--text);
    background: var(--accent-dim);
  }
  .wrap {
    max-width: var(--max-w);
    margin: 0 auto;
    padding: 0 var(--gutter);
  }
  .ribbon-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
  }
  .ribbon-l {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ribbon-l :global(svg) {
    color: var(--accent);
  }
  :global([data-theme='brutalist']) .ribbon-l :global(svg) {
    color: var(--text);
  }
  .ribbon-l-text {
    font-size: 14px;
    color: var(--text-2);
  }
  .ribbon-l-text strong {
    color: var(--text);
    font-weight: 700;
  }
  :global([data-theme='brutalist']) .ribbon-l-text strong {
    font-weight: 800;
  }
  .ribbon-r {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  .ribbon-chip {
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 500;
    background: var(--bg);
    color: var(--text-2);
    border: 1px solid var(--border);
    border-radius: 999px;
  }
  :global([data-theme='brutalist']) .ribbon-chip {
    border: 2px solid var(--text);
    border-radius: 0;
    background: var(--bg);
    color: var(--text);
    font-weight: 700;
  }
</style>
